import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SiNewtonLoadingService } from '@simpl/newton-ng/loading-spinner';
import { DataTransferService } from 'src/app/services/data-transfer.service';
import { FormDataService } from 'src/app/services/form-data.service';
import { ProductPriceServiceService } from 'src/app/services/product-price-service.service';

export interface DropDownOption {
  value: string;
}
@Component({
  selector: 'app-ivm',
  templateUrl: './ivm.component.html',
  styleUrls: ['./ivm.component.scss']
})
export class IvmComponent {
  isThisSectionVisible = false;
  priceWarnings: string[] = [];

  toggleVisibility() {
    console.log(this.isThisSectionVisible);
    this.isThisSectionVisible = !this.isThisSectionVisible;
  }

  @Input()
  public parentForm!: FormGroup;

  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  @Output()
  submitValues: EventEmitter<any> = new EventEmitter();

  counter(i: number) {
    return new Array(i);
  }

  stringToNumber(num: string) {
    return parseInt(num, 10);
  }

  constructor(
    private formDataService: FormDataService,
    private dataTransferService: DataTransferService,
    private loadingSpinner: SiNewtonLoadingService,
    private productPriceService: ProductPriceServiceService
  ) {}

  public getDropdownOptions(formControlName: string) {
    return this.formDataService.getDropDownOptions(formControlName);
  }

  public getDropdownValue(dropDownOption: DropDownOption): string {
    return dropDownOption.value;
  }

  async submit() {
    const jsonData = await this.formDataService.getDataFromDialog(this.parentForm);

    await this.dataTransferService.writeDataToExcel(JSON.stringify(jsonData));

    await this.readData();
  }

  async readData() {
    const keysFromDialog = await this.formDataService.getAllControlsFromDialogAsArray(this.parentForm);

    const formData = (await this.dataTransferService.getValuesFromExcel(keysFromDialog)) as any;

    this.formDataService.fillDataIntoDialog(this.parentForm, formData);
  }

  async getPricesForAllMlfbs() {
    this.loadingSpinner.startLoading();

    try {
      // Collect all MLFB values from ivmServiceMlfb1 to ivmServiceMlfb11
      const mlfbValues: string[] = [];
      const mlfbToIndexMap: { [key: string]: number } = {};
      const ivmForm = this.parentForm.get('ivmForm');

      for (let i = 1; i <= 11; i++) {
        const mlfbControl = ivmForm?.get(`ivmServiceMlfb${i}`);
        const mlfbValue = mlfbControl?.value;

        if (mlfbValue && mlfbValue.trim() !== '') {
          const trimmedMlfb = mlfbValue.trim();
          mlfbValues.push(trimmedMlfb);
          mlfbToIndexMap[trimmedMlfb] = i;
        }
      }

      if (mlfbValues.length === 0) {
        console.warn('No MLFB values found to fetch prices for');
        this.loadingSpinner.stopLoading();
        return;
      }

      const mlfbElementsCommaSeperated = mlfbValues.join(',');
      const priceMflbList = (await this.productPriceService.getCurrentPricesByMlfbList(mlfbElementsCommaSeperated)) as any;

      console.log('Price MLFB List:', priceMflbList);

      // Populate price fields with returned data
      if (priceMflbList && typeof priceMflbList === 'object') {
        const onDemandWarnings: string[] = [];

        // Iterate through the object keys (MLFBs)
        Object.keys(priceMflbList).forEach((mlfb: string) => {
          const price = priceMflbList[mlfb];
          const serviceIndex = mlfbToIndexMap[mlfb];

          if (serviceIndex && ivmForm) {
            const priceControl = ivmForm.get(`ivmServicePrice${serviceIndex}`);

            if (priceControl) {
              // Check if price is "on demand"
              const priceString = price?.toString().toLowerCase();
              const isOnDemand =
                priceString === 'on demand' || priceString === 'ondemand' || priceString === 'on-demand' || priceString === 'demand';

              if (isOnDemand) {
                priceControl.setValue(0);
                onDemandWarnings.push(`Service ${serviceIndex} (${mlfb}): Price is on demand`);
              } else {
                // Convert price to number if it's a valid numeric value
                const numericPrice = parseFloat(price);
                if (!isNaN(numericPrice)) {
                  priceControl.setValue(numericPrice);
                  priceControl.markAsDirty();
                  priceControl.markAsUntouched();
                } else {
                  priceControl.setValue(0);
                  onDemandWarnings.push(`Service ${serviceIndex} (${mlfb}): Invalid price format, set to 0`);
                }
              }
            }
          }
        });

        // Display warnings for "on demand" prices
        if (onDemandWarnings.length > 0) {
          this.priceWarnings = onDemandWarnings;
          console.warn('On demand prices found:', onDemandWarnings);
        } else {
          this.priceWarnings = [];
        }

        this.submitValues.emit();
      } else {
        console.warn('No price data returned from service');
      }
    } catch (error) {
      console.error('Error fetching prices:', error);
      alert('Failed to fetch prices. Please try again.');
    } finally {
      this.loadingSpinner.stopLoading();
    }
  }
}
